// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__13hCf","title":"ClientCherryInfo_title__VB9fb","itemText":"ClientCherryInfo_itemText__1YwOM"};